// constants
export const constants = {
  invoice: {
    SameDayLabel: 'Immediate',
    ApprovalCheckbox: 'ApprovalCheckbox',
    USD: 'USD'
  },

  columnType: {
    List: 'list',
    Date: 'date',
    Money: 'money',
    Percent: 'percent',
    Qty: 'qty',
    Text: 'text'
  }
}



// WEBPACK FOOTER //
// ./src/core/utils/constants.js